var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSquareLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0129 6.78983L6.68594 10.1296M6.68594 10.1296L10.0257 13.4565M6.68594 10.1296L13.3526 10.1167M13.5048 2.61643L6.50484 2.62991C5.10471 2.6326 4.40464 2.63395 3.87039 2.90746C3.40045 3.14805 3.01873 3.53124 2.77995 4.0021C2.5085 4.53741 2.50985 5.23747 2.51254 6.6376L2.52602 13.6376C2.52871 15.0377 2.53006 15.7378 2.80358 16.272C3.04416 16.742 3.42735 17.1237 3.89822 17.3625C4.43352 17.6339 5.13358 17.6326 6.53371 17.6299L13.5337 17.6164C14.9338 17.6137 15.6339 17.6124 16.1681 17.3388C16.6381 17.0983 17.0198 16.7151 17.2586 16.2442C17.53 15.7089 17.5287 15.0088 17.526 13.6087L17.5125 6.60872C17.5098 5.2086 17.5085 4.50853 17.235 3.97428C16.9944 3.50434 16.6112 3.12262 16.1403 2.88384C15.605 2.61239 14.905 2.61374 13.5048 2.61643Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareLeft);
export default __webpack_public_path__ + "static/media/arrow-square-left.142f011aff6c775f9c58dab667231d9e.svg";
export { ForwardRef as ReactComponent };